import { render, staticRenderFns } from "./CommstrackerDomainCreateOrUpdateDialog.vue?vue&type=template&id=650ed458"
import script from "./CommstrackerDomainCreateOrUpdateDialog.vue?vue&type=script&lang=js"
export * from "./CommstrackerDomainCreateOrUpdateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports